import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { FaPlay } from 'react-icons/fa'
import Sectionbreak from './Sectionbreak'
import poster from '../assets/images/projects/kanombe/Kanombe4.jpg'

const YOUTUBE_ID = '7Li8YHs5dQg'

function VideoSection() {
  const [isPlaying, setIsPlaying] = useState(false)

  return (
    <section className="w-full pt-10 bg-gradient-to-br from-[#fdf1eb] via-[#f1f9fa] to-[#e4f4fd]">
      <div className="max-w-7xl mx-auto px-1 grid md:grid-cols-3 gap-5 items-center">
        
        {/* LEFT */}
        <div>
          <Sectionbreak
            title="Experience"
            highlight="Our Vision"
            description="Watch how our developments come to life through design, sustainability, and innovation."
            className="text-left"
          />
        </div>

        {/* RIGHT */}
        <div className="relative w-full aspect-video md:col-span-2 bg-white/70 backdrop-blur-sm overflow-hidden rounded-lg">
          
          {!isPlaying ? (
            <>
              {/* Poster */}
              <img
                src={poster}
                alt="Video preview"
                className="w-full h-full object-cover"
              />

              {/* Play Button */}
              <button
                onClick={() => setIsPlaying(true)}
                className="absolute inset-0 flex items-center justify-center"
              >
                <motion.div
                  className="w-16 h-16 rounded-full bg-white text-teal-600 flex items-center justify-center shadow-lg"
                  animate={{
                    scale: [1, 1.15, 1],
                  }}
                  transition={{
                    repeat: Infinity,
                    duration: 1.5,
                    ease: 'easeInOut',
                  }}
                >
                  <FaPlay className="text-xl ml-1" />
                </motion.div>
              </button>
            </>
          ) : (
            /* YouTube iframe */
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${YOUTUBE_ID}?autoplay=1&rel=0`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default VideoSection
